// ** React Imports
import { useEffect, useState, createContext } from 'react'

// ** Create Context
const ChatbotContext = createContext()

const STORAGE_KEY = 'chatbot_history'

const ChatbotProvider = ({ children }) => {
  // ** State
  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  // ** Load from sessionStorage on mount
  useEffect(() => {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY)
      if (stored) {
        const parsed = JSON.parse(stored)
        if (Array.isArray(parsed)) {
          setMessages(parsed)
        }
      }
    } catch (error) {
      console.error('Error loading chatbot history:', error)
    }
  }, [])

  // ** Save to sessionStorage on messages change
  useEffect(() => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(messages))
    } catch (error) {
      console.error('Error saving chatbot history:', error)
    }
  }, [messages])

  // ** Add message helper
  const addMessage = (role, content) => {
    const newMessage = {
      id: Date.now(),
      role,
      content,
      timestamp: new Date().toISOString()
    }
    setMessages(prev => [...prev, newMessage])
    return newMessage
  }

  // ** Clear history
  const clearHistory = () => {
    setMessages([])
    sessionStorage.removeItem(STORAGE_KEY)
  }

  // ** Toggle chat
  const toggleChat = () => {
    setIsOpen(prev => !prev)
  }

  const value = {
    isOpen,
    setIsOpen,
    messages,
    setMessages,
    isLoading,
    setIsLoading,
    addMessage,
    clearHistory,
    toggleChat
  }

  return <ChatbotContext.Provider value={value}>{children}</ChatbotContext.Provider>
}

export { ChatbotContext, ChatbotProvider }
